// AUTH
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";

export const GET_BILDIRGE_ISLEMLERI_LIST_SECCUSS = "GET_BILDIRGE_ISLEMLERI_LIST_SECCUSS";

// APP
export const SET_LOADING = "SET_LOADING";